/* External */
import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
/* Components */
import FocusableButton from '../FocusableButton';
/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { useOnBackPress } from '../../utils/keyDownEvents';

function CotentLeaveModal({
  icon,
  title,
  buttonLeave,
  buttonNotNow,
  isModalShown,
  onEnterPress,
  realFocusKey,
  setFocus,
  onExitAppPress,
  handleBackButtonPress,
}) {
  const buttonFocusKey = `${realFocusKey}_button`;
  const buttonNotNowFocusKey = `${realFocusKey}_button-not-now`;
  useEffect(() => {
    if (isModalShown) {
      setFocus(buttonFocusKey);
    }
  }, [setFocus, buttonFocusKey, isModalShown]);

  useOnBackPress({
    listener: handleBackButtonPress,
    priority: 10,
  });

  return (
    <div className="dtv-html5-c-want-to-leave-modal__content">
      <img loading="lazy" decoding="async" src={icon} className="dtv-html5-c-want-to-leave-modal__icon" alt="icon" />
      <h1 className="dtv-html5-c-want-to-leave-modal__title">
        {title}
      </h1>
      <div className="dtv-html5-c-want-to-leave-modal__button__wrap">
        <FocusableButton
          className="dtv-html5-c-want-to-leave-modal__button"
          onEnterPress={onExitAppPress}
          focusKey={buttonFocusKey}
          primary
          bordered
        >
          {buttonLeave}
        </FocusableButton>
        <FocusableButton
          className="dtv-html5-c-want-to-leave-modal__button"
          onEnterPress={onEnterPress}
          focusKey={buttonNotNowFocusKey}
          primary
          bordered
        >
          {buttonNotNow}
        </FocusableButton>
      </div>
    </div>
  );
}
CotentLeaveModal.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  buttonLeave: PropTypes.node.isRequired,
  buttonNotNow: PropTypes.node.isRequired,
  isModalShown: PropTypes.bool.isRequired,
  onEnterPress: PropTypes.func.isRequired,
  onExitAppPress: PropTypes.func.isRequired,
  realFocusKey: PropTypes.string.isRequired,
  setFocus: PropTypes.func.isRequired,
  handleBackButtonPress: PropTypes.func.isRequired,
};
export default memo(withInteractiveFocusable()(memo(CotentLeaveModal)));
